import React from "react";
import * as c from "./textInput.module.scss";
import classNames from "classnames";

const TextInput = React.forwardRef((props, ref) => {
  const {
    tabIndex,
    type,
    name,
    required,
    placeholder,
    className,
    children,
    label,
    errors,
    onFocus,
    onBlur,
    v2,
    minLength,
    defaultValue,
    onChange,
    autoComplete,
    onPaste,
    disabled,
  } = props;

  const cx = classNames(
    {
      [c.v2]: v2,
      [c.disabled]: disabled,
    },
    c.container,
    className
  );

  let labelEl;
  if (label) {
    labelEl = (
      <label htmlFor={name} className={c.label}>
        {label}
      </label>
    );
  }

  let errorEl;
  if (errors) {
    const error = errors[name];

    if (error) {
      errorEl = <div className={c.error}>{error.message}</div>;
    }
  }

  return (
    <div className={cx}>
      {labelEl}
      <input
        tabIndex={tabIndex}
        type={type}
        name={name}
        id={name}
        required={required}
        placeholder={placeholder}
        className={classNames(c.input, { [c.disabled]: disabled })}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={ref}
        minLength={minLength}
        onChange={onChange}
        autoComplete={autoComplete}
        defaultValue={defaultValue}
        onPaste={onPaste}
        disabled={disabled}
        aria-invalid={errors?.[name] ? "true" : "false"}
      />
      {children}
      {errorEl}
    </div>
  );
});

export default TextInput;
